import React from "react";

export default function Grids({ pxWidth, pxHeight, maxHeight }) {
    return (
        <g>
            {/* x-axis */}
            <line
                x1={pxWidth * 0.1}
                y1={pxHeight * 0.85}
                x2={pxWidth * 0.99}
                y2={pxHeight * 0.85}
                stroke="#000"
                strokeWidth={pxHeight * 0.002}
            />
            {/* y-axis */}
            <line
                x1={pxWidth * 0.1}
                y1={pxHeight * 0.85}
                x2={pxWidth * 0.1}
                y2={pxHeight * 0.05}
                stroke="#000"
                strokeWidth={pxHeight * 0.002}
            />

            {/* Horizontal lines */}
            {Array.from({ length: 11 }).map((_, index) => {
                const y = pxHeight * 0.05 + index * ((pxHeight * 0.8) / 10);
                return (
                    <line
                        key={index}
                        x1={pxWidth * 0.1}
                        y1={y}
                        x2={pxWidth * 0.99}
                        y2={y}
                        stroke="#888"
                        strokeWidth={pxHeight * 0.001}
                        strokeDasharray={pxHeight * 0.005}
                    />
                );
            })}

            {/* Paints y-axis data */}
            {Array.from({ length: 11 }).map((_, index) => {
                    const y =
                        pxHeight * 0.055 +
                        index * ((pxHeight * 0.8) / 10);
                    const step = maxHeight / 10;
                    return (
                        <text
                            key={index}
                            x={pxWidth * 0.075}
                            y={y}
                            textAnchor="end"
                            fontSize={pxHeight * 0.03}
                        >
                            {Math.round(step * (10 - index))}
                        </text>
                    );
                })}
        </g>
    );
}
